import React from 'react';
import { Home as HomeIcon, Building2, TrendingUp, Layers, Briefcase, Sparkles, Wind, Sofa, Scissors } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: HomeIcon,
      title: 'Čišćenje Kuća',
      description: 'Kompletne usluge čišćenja stambenih objekata. Od spavaćih soba do kuhinja, osiguravamo da svaki ugao blistavo sija.',
      features: ['Generalno čišćenje', 'Dubinsko čišćenje', 'Redovno održavanje', 'Čišćenje pri useljenju/iseljenju']
    },
    {
      icon: Layers,
      title: 'Čišćenje Tepiha',
      description: 'Profesionalno čišćenje tepiha naprednim tehnikama za uklanjanje mrlja, prljavštine i alergena sa vaših tepiha.',
      features: ['Uklanjanje mrlja', 'Dubinsko parno čišćenje', 'Eliminacija mirisa']
    },
    {
      icon: TrendingUp,
      title: 'Čišćenje Stepenica',
      description: 'Specijalizovano čišćenje stepeništa, ograda i teško dostupnih oblasti osiguravajući bezbednost i čistoću.',
      features: ['Dezinfekcija rukohvata', 'Čišćenje gazišta', 'Detaljno čišćenje uglova']
    },
    {
      icon: Briefcase,
      title: 'Čišćenje Kancelarija',
      description: 'Održite vaš radni prostor profesionalnim i produktivnim uz naša sveobuhvatna rešenja za čišćenje kancelarija.',
      features: ['Generalno čišćenje', 'Dezinfekcija radnih stolova', 'Održavanje podova', 'Čišćenje prostorija za odmor']
    },
    {
      icon: Building2,
      title: 'Čišćenje Zgrada',
      description: 'Komercijalno čišćenje velikih razmera za zgrade, skladišta i objekte svih veličina.',
      features: ['Generalno čišćenje', 'Čišćenje spoljašnosti', 'Zajednički prostori', 'Pranje prozora']
    },
    {
      icon: Sparkles,
      title: 'Pranje Prozora',
      description: 'Kristalno čisti prozori uz profesionalno pranje unutrašnjih i spoljašnjih površina za savršen pogled.',
      features: ['Bez tragova i pruga', 'Čišćenje okvira', 'Visoki objekti']
    },
    {
      icon: Wind,
      title: 'Pranje i Poliranje Podova',
      description: 'Dubinsko pranje i poliranje svih vrsta podova - parket, pločice, mermer za sjajan i trajan rezultat.',
      features: ['Mašinsko poliranje', 'Zaštitni premazi', 'Restauracija podova']
    },
    {
      icon: Scissors,
      title: 'Košenje Trave',
      description: 'Profesionalna nega dvorišta i travnjaka uz redovno košenje i održavanje zelenih površina.',
      features: ['Precizno košenje', 'Uklanjanje korova', 'Sezonsko održavanje']
    },
    {
      icon: Sofa,
      title: 'Dubinsko Pranje Nameštaja',
      description: 'Specijalizovano dubinsko pranje tapaciranog nameštaja uz uklanjanje fleka i osvežavanje materijala.',
      features: ['Pranje sofa i fotelja', 'Uklanjanje neprijatnih mirisa', 'Zaštita tkanina']
    }
  ];

  return (
    <section id="services" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-blue-100 rounded-full mb-4">
            <span className="text-blue-700 font-semibold text-sm">Šta Radimo</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Naše Usluge Čišćenja
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Profesionalna rešenja za čišćenje prilagođena vašim potrebama
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div 
                key={index}
                className="group bg-white border border-gray-200 rounded-2xl p-8 hover:border-blue-300 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-6 group-hover:bg-blue-600 transition-colors">
                  <Icon className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors" />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>

                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-gray-700">
                      <div className="w-1.5 h-1.5 bg-blue-600 rounded-full"></div>
                      <span className="text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="mt-16 mb-16">
          <img 
            src="https://customer-assets.emergentagent.com/job_0f16aa0d-de66-4ccd-9f5e-83393c2a92ba/artifacts/s4ilg43j_Limpieza-de-oficinas-770x578-1%20%281%29.png"
            alt="Profesionalno čišćenje"
            className="w-full max-w-4xl mx-auto rounded-2xl shadow-lg"
          />
        </div>

        <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-12 text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Potrebno Vam je Prilagođeno Rešenje za Čišćenje?</h3>
          <p className="text-blue-100 mb-8 text-lg max-w-2xl mx-auto">
            Nudimo fleksibilne pakete čišćenja prilagođene vašim specifičnim zahtevima. Razgovarajmo o vašim potrebama!
          </p>
          <button 
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-all hover:scale-105"
          >
            Kontaktirajte Nas Danas
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
